import * as React from "react";
import { Header } from './components/Header';
import { Panel } from './components/Panel';

export class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        
        }
    }
// <Panel type='SidePanel' />
//                 <Panel type='SidePanel' isLeft={true} />
//<Panel type='SidePanel' flipped={false}/>
    render() {
        return (
            <span>
                <Header />
                <div className='wrapper'> 
                    <Panel type='SidePanel' flipped={true}/>
                    <Panel type='MainPanel' />
                </div>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./react/App.jsx